<template>
    <div>
        <div class="flex justify-between border-b border-grayxlight mb-3 ds-exchange-panel-section">
            <div>Копирование вакансии</div>
            <div class="ds-exchange-history-toggle" @click="isOpen = !isOpen">
                <span v-if="isOpen">Свернуть</span>
                <span v-else>Развернуть</span>
            </div>
        </div>
        <div v-if="isOpen">
            <div class="ds-exchange-field-label">Выберите дни для копирования</div>
            <div class="w-full">
                <AppCalendar :model-value="date" mode="range" :min-date="props.minDate" large @update:model-value="onSelect" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Dayjs } from 'dayjs'
import { ref } from 'vue'
import AppCalendar from '@/ui/AppCalendar.vue'

const emit = defineEmits(['selected'])
const props = defineProps<{ minDate: Dayjs }>()

const isOpen = ref(false)
const date = ref<[Dayjs, Dayjs] | null>(null)

function onSelect(value: Dayjs | [Dayjs, Dayjs] | Dayjs[]) {
    date.value = value as [Dayjs, Dayjs]
    const [start, end] = date.value
    if (start && end) {
        emit('selected', date.value)
    }
}
</script>
